module.exports = __webpack_public_path__ + "img/avatar_random_6.d7205add.png";